<breadcrumb></breadcrumb>

<div class="matero-row" fxLayout="row wrap">

  <!-- Statistics -->
  <div class="matero-col" fxFlex="100" fxFlex.gt-sm="100">
    <div fxLayout="row wrap">
      <div class="matero-col m-t-64" fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100"
         style="margin-top: 64px; margin-left: auto; margin-right: auto;"   >
           <h1>Hệ thống phân phối bài giảng Bigben</h1>
           <p>©2023 bigben.edu.vn</p>
      </div>
    </div>
  </div> 
</div>